module.exports = __webpack_public_path__ + "static/media/01.66f7e046.png";